import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Shymkent.png'
import _imports_1 from '@/assets/images/shymkent1.jpg'
import _imports_2 from '@/assets/images/shymkent2.jpeg'
import _imports_3 from '@/assets/images/shymkent3.jpg'
import _imports_4 from '@/assets/images/shymkent4.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Достопримечательности Шымкента"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Этому городу более 2000 лет, когда-то здесь проходил Великий Шелковый путь. Сегодня о нем напоминают шумные восточные базары, этноисторический комплекс «Казына», и многие другие места, любимые для посещения туристами. Речь идет о Шымкенте, который в народе называют «городом-садом». И, действительно, город словно утопает в зелени. Шымкент один из крупнейших культурных, промышленных и торговых центров Казахстана, второй по численности населения мегаполис страны. И как показывает статистика по туризму республики – еще и весьма популярный у путешественников. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Что Посмотреть В Шымкенте?")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Любой путешественник найдет в городе развлечения на свой вкус. Для пеших прогулок подойдут дендропарк, многочисленные городские парки отдыха и аллеи, набережная реки Кошкараты. Детям будет интересно в местном зоопарке, Южно-Казахстанском областном театре кукол и юного зрителя, технопарке «Мир фантазий», а еще - посетить необычное сооружение «Перевернутый дом». Практически в центре города расположены этноисторический комплекс «Казына» и этнографический парк «Кен-баба». На территории парка «Кен-баба» действуют спортивные и детские игровые площадки, аттракционы, песчаный и зеленый городки, демонстрационный макет «Казахстан в миниатюре», множество прудов, каналов и даже настоящий водопад. "),
        /*#__PURE__*/_createVNode("p", null, " Статистика туризма Шымкента утверждает: большинство путешественников приезжают сюда в теплый сезон, и для их комфорта власти поставили перед собой задачу создать в городе настоящий цветущий оазис с приятным климатом. Ни в одном другом городе страны нет такого огромного количества водных объектов: бассейнов, фонтанов, аквапарков и водных аттракционов. "),
        /*#__PURE__*/_createVNode("p", null, " В последние годы в Шымкенте и его окрестностях активно развивается внутренний туризм – по данным статистики, познакомиться с историческими достопримечательностями региона хотят не только иностранные путешественники, но и казахстанцы. ")
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "4593")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "26,8")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "215951")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "33362")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, " Что Посмотреть В Окрестностях Города? ")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createTextVNode(" Из Шымкента организуются туры выходного дня к историческим достопримечательностям Туркестанской области. Туристы посещают "),
        /*#__PURE__*/_createVNode("strong", null, "мавзолеи Арыстан-Баба, Ходжи Ахмеда Ясави и Домалак-Ана, гробницы казахских ханов Есима, Аблая, Абулхаира и других"),
        /*#__PURE__*/_createTextVNode(", популярны экскурсии к руинам "),
        /*#__PURE__*/_createVNode("strong", null, "древних городов Отрара и Саурана"),
        /*#__PURE__*/_createTextVNode(". Недалеко от мегаполиса находится и самая таинственная пещера Казахстана – Акмешит. ")
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Перспективы Отрасли")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Как развивается туризм в Шымкенте? Досуг для гостей города организуют более ста туристических компаний Шымкента. Здесь всегда есть, куда сходить, на что посмотреть. Наибольшей популярностью пользуется посещение исторических мест. Также путешественникам интересны пешие, конные и автомобильные прогулки в экзотические районы в окрестностях Шымкента (например, выезд к горе Казыгурт). Для любителей природы открыты двери Сайрам-Угамского национального парка и Аксу-Жабаглинского заповедника. Есть отличные места для , охоты и рыбалки. "),
        /*#__PURE__*/_createVNode("p", null, " В 2019 году представителями местной власти была подготовлена программа развития туризма в регионе. Органичное сочетание культурных и природных достопримечательностей, национальных традиций и местная кухня – вот главные составляющие туристического потенциала города. ")
      ])
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "regio-swiper" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}